import { IFeatureFlagWithBVT } from '../../../utils/bvt-feature-flags/types';

export enum FeatureFlagNames {
    application = 'application',
    orderListSearch = 'orderListSearch',
    orderExpress = 'orderExpress',
    advanceDownload = 'advanceDownload',
    orderEnquiry = 'orderEnquiry',
    orderTrackerInt = 'orderTrackerInt',
    orderTrackerDetailInt = 'orderTrackerDetailInt',
    orderTrackerUpdateBanner = 'orderTrackerUpdateBanner',
    orderDetailDeliveryAddress = 'orderDetailDeliveryAddress',
    orderInfoTip = 'orderInfoTip',
    ponrFooterFlag = 'ponrFooterFlag',
    showRequestNumber = 'showRequestNumber',
    orderDetailCustomerAcceptanceInt = 'orderDetailCustomerAcceptanceInt',
    visible = 'visible',
    fullListPage = 'fullListPage',
    upcomingAppointmentFlag = 'upcomingAppointmentFlag',
    orderListColumnChanges = 'orderListColumnChanges',
    displayRamboProductCategory = 'displayRamboProductCategory',
    yourReferenceInt = 'yourReferenceInt',
    orderListReferenceInt = 'orderListReferenceInt',
    legacyOrderDetailsSubStageStatus = 'legacyOrderDetailsSubStageStatus',
    hideDatefieldNoDataFromDownstream = 'hideDatefieldNoDataFromDownstream',
    tedig3296UpliftedOrderDetails = 'tedig3296UpliftedOrderDetails',
    tedig3007OrderListChanges = 'tedig3007OrderListChanges',
    orderTrackerIntUIUpliftment = 'orderTrackerIntUIUpliftment',
    orderTrackerDetailsIntUIUpliftment = 'orderTrackerDetailsIntUIUpliftment',
    tedig3007OrderListPart2 = 'tedig3007OrderListPart2',
    tedig3007OrderListExportButton = 'tedig3007OrderListExportButton',
    tedig4307Dynamic5g = 'tedig4307Dynamic5g',
    disablePdfDownloadInt = 'disablePdfDownloadInt'
}

export interface IFeatureFlags {
    [FeatureFlagNames.application]: boolean;
    [FeatureFlagNames.orderListSearch]: boolean;
    [FeatureFlagNames.orderExpress]: boolean;
    [FeatureFlagNames.advanceDownload]: boolean;
    [FeatureFlagNames.orderEnquiry]: boolean;
    [FeatureFlagNames.orderTrackerInt]: boolean;
    [FeatureFlagNames.orderTrackerDetailInt]: boolean;
    [FeatureFlagNames.orderTrackerUpdateBanner]: boolean;
    [FeatureFlagNames.orderDetailDeliveryAddress]: boolean;
    [FeatureFlagNames.orderInfoTip]: boolean;
    [FeatureFlagNames.ponrFooterFlag]: boolean;
    [FeatureFlagNames.showRequestNumber]: boolean;
    [FeatureFlagNames.orderDetailCustomerAcceptanceInt]: boolean;
    [FeatureFlagNames.visible]: boolean;
    [FeatureFlagNames.fullListPage]: boolean;
    [FeatureFlagNames.upcomingAppointmentFlag]: boolean;
    [FeatureFlagNames.orderListColumnChanges]: boolean;
    [FeatureFlagNames.displayRamboProductCategory]: boolean;
    [FeatureFlagNames.yourReferenceInt]: boolean;
    [FeatureFlagNames.orderListReferenceInt]: boolean;
    [FeatureFlagNames.legacyOrderDetailsSubStageStatus]: boolean;
    [FeatureFlagNames.hideDatefieldNoDataFromDownstream]: boolean;
    [FeatureFlagNames.tedig3296UpliftedOrderDetails]: IFeatureFlagWithBVT;
    [FeatureFlagNames.tedig3007OrderListChanges]: IFeatureFlagWithBVT;
    [FeatureFlagNames.orderTrackerIntUIUpliftment]: boolean;
    [FeatureFlagNames.orderTrackerDetailsIntUIUpliftment]: boolean;
    [FeatureFlagNames.tedig3007OrderListPart2]: IFeatureFlagWithBVT;
    [FeatureFlagNames.tedig3007OrderListExportButton]: boolean;
    [FeatureFlagNames.tedig4307Dynamic5g]: IFeatureFlagWithBVT;
    [FeatureFlagNames.disablePdfDownloadInt]: boolean
}
